<template>
  <v-container fluid id="tf-faq" class="tf-faq-section py-8 py-md-16">
    <v-container>

      <v-row class="mb-8">
        <v-col cols="12" class="text-center">
          <span
            class="overline font-weight-bold"
            :style="{ color: '#00695C' }"
            data-aos="fade-down"
          >
            PREGUNTAS FRECUENTES
          </span>
          <h2
            class="display-1 font-weight-bold primary--text mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Todo lo que necesitás saber sobre TradeFlow
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="8"
          class="ma-auto"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <v-expansion-panels flat>
            <v-expansion-panel
              v-for="(faq, index) in faqs"
              :key="index"
              class="mb-3 rounded-lg"
              elevation="1"
            >
              <v-expansion-panel-header
                class="py-6 text-h6 font-weight-medium primary--text"
              >
                {{ faq.question }}
              </v-expansion-panel-header>
              <v-expansion-panel-content
                class="greylight--text text-body-1 pt-4"
              >
                <span v-html="faq.answer"></span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'TFFAQ',
  data() {
    return {
      faqs: [
        {
          question: '¿Qué tipos de documentos puedo gestionar con TradeFlow?',
          // eslint-disable-next-line max-len
          answer: '<strong>Todos los documentos de comercio exterior:</strong> Bill of Lading, Packing List, Factura Comercial, Certificado de Origen, Pedimento de Importación/Exportación y documentos aduanales complementarios. Las plantillas se configuran según tu operación específica.',
        },
        {
          question: '¿Cómo funciona la validación AI de documentos aduanales?',
          // eslint-disable-next-line max-len
          answer: '<strong>La AI revisa automáticamente cada documento</strong> contra los datos del pedimento y la factura comercial. Detecta inconsistencias en valores, partidas arancelarias, datos del importador/exportador y fechas. Recibís una alerta antes de presentar al SAT.',
        },
        {
          question: '¿TradeFlow se integra con el VUCEM?',
          // eslint-disable-next-line max-len
          answer: '<strong>Sí, en el plan Empresa y Corporativo.</strong> TradeFlow se conecta con el VUCEM para consultar el estatus de tus trámites en tiempo real, sin necesidad de ingresar manualmente al portal.',
        },
        {
          question: '¿Cuánto tiempo lleva la implementación?',
          // eslint-disable-next-line max-len
          answer: '<strong>En 7 días ya tenés tu primer proceso operativo.</strong> Comenzamos con una demo personalizada de tu operación, luego configuramos tus plantillas de documentos y flujos de aprobación, y finalmente capacitamos a tu equipo.',
        },
        {
          question: '¿TradeFlow sirve tanto para importación como para exportación?',
          // eslint-disable-next-line max-len
          answer: '<strong>Sí, está diseñado para las dos operaciones.</strong> Podés gestionar embarques de importación con control de pedimentos y derechos aduanales, y al mismo tiempo gestionar exportaciones con BLs, certificados de origen y documentos de embarque.',
        },
        {
          question: '¿Cómo funciona la prueba gratis de 14 días?',
          // eslint-disable-next-line max-len
          answer: '<strong>Sin tarjeta de crédito y con acceso completo a todas las funciones de tu plan.</strong> Durante los 14 días podés cargar embarques reales, configurar tus documentos y probar la validación AI. Al finalizar, elegís si continuás o no.',
        },
        {
          question: '¿Mis datos y documentos están seguros?',
          // eslint-disable-next-line max-len
          answer: '<strong>TradeFlow usa cifrado AES-256 en reposo y TLS 1.3 en tránsito.</strong> Los documentos se almacenan en servidores certificados con SOC 2 Tipo II. Podés controlar permisos por usuario para que cada colaborador acceda solo a lo que necesita.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tf-faq-section {
  background-color: #F5F5F5;
}
</style>
